import { render, staticRenderFns } from "./CustomerUploadItem.vue?vue&type=template&id=2f0cab74&"
import script from "./CustomerUploadItem.vue?vue&type=script&lang=ts&"
export * from "./CustomerUploadItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports